var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUpload(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    enableBackground: "new 0 0 24 24",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M7.903,10.105c0.192,0,0.384-0.073,0.53-0.22l2.836-2.836v8.317c0,0.414,0.336,0.75,0.75,0.75s0.75-0.336,0.75-0.75V7.065 l2.82,2.82c0.146,0.146,0.338,0.22,0.53,0.22s0.384-0.073,0.53-0.22c0.293-0.293,0.293-0.768,0-1.061l-4.098-4.098 c-0.075-0.075-0.162-0.129-0.254-0.166C12.026,4.446,11.7,4.497,11.478,4.72L7.373,8.825c-0.293,0.293-0.293,0.768,0,1.061 C7.519,10.032,7.711,10.105,7.903,10.105z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.49,18H6.51c-0.414,0-0.75,0.336-0.75,0.75s0.336,0.75,0.75,0.75h10.98c0.414,0,0.75-0.336,0.75-0.75 S17.904,18,17.49,18z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpload);
export default __webpack_public_path__ + "static/media/upload.3dbb94ad541e975813b09d5269878510.svg";
export { ForwardRef as ReactComponent };